<template><div><h1>VUX V2.0.1 released</h1>
<h2><a href="/en/components/loading.html">Loading</a></h2>
<ul></ul>
<h2><a href="/en/components/x-input.html">XInput</a></h2>
<ul></ul></div></template><script>
export default {
  head: {"title":"VUX V2.0.1 released | VUX - Vue.js Mobile UI Component Framework","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.0.1-65.vue?0446eafa